import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';
import { NavigationService } from 'src/app/core/navigation.service';

@Component({
  selector: 'app-agent-builder-form',
  templateUrl: './agent-builder-form.component.html',
  styleUrls: ['./agent-builder-form.component.scss'],
})
export class AgentBuilderFormComponent {
  agent_builder_form_group: FormGroup = this.form_service.agent_builder_form_group;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;

  constructor(private form_service: FormService, private navigation_service: NavigationService) {}

  onConfirmClick(): void {
    this.navigation_service.toOrganizationBuilder();
  }
}
